export const CUSTOMER_QUOTATION_RETRIEVED = 'CUSTOMER_QUOTATION_RETRIEVED';

export function customerQuotationRetrieved(customerQuotation) {
  return {
    type: CUSTOMER_QUOTATION_RETRIEVED,
    customerQuotation,
  };
}



// WEBPACK FOOTER //
// ./src/services/DataServices/CustomerQuotationService/actions.js